<template>
  <div>
    <header-title
      title="قائمة المنظمات "
      titlePrevious="الرئيسية"
      color="#164e63"
    />
    <div class="container d-flex flex-column">
      <div class="filter_small_screen">
        <collapse-header title_img="filter" title="بحث بحسب">
          <div class="widget">
            <div class="p-2">
              <div class="mb-1 w-100">
                <div class="mx-1">اسم المنظمة</div>
                <b-form-input
                  id="basicInput"
                  v-model="nameOrg"
                  placeholder=""
                />
              </div>

              <div class="mb-1 w-100">
                <form-select
                  label="الفئة المستهدفة"
                  v-model="selectedCategories"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x.id"
                  id="governorate"
                  ep="v2/guest/selects/age-categories"
                  multiple
                />
              </div>

              <div class="mb-1 w-100">
                <form-select
                  label="التصنيف"
                  v-model="selectedClassi"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x.id"
                  id="selectedCategories"
                  ep="v2/guest/selects/classifications"
                />
              </div>

              <div class="mb-1 w-100">
                <form-select
                  label="المحافظة"
                  v-model="selectedGovernorate"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x.id"
                  id="sgovernorate"
                  ep="v2/guest/selects/governorates"
                />
              </div>

              <div class="mb-1 w-100">
                <form-select
                  label="الشكل القانوني "
                  v-model="selectedLegals"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x.id"
                  id="selectedLegals"
                  ep="v2/guest/selects/legal-forms"
                />
              </div>
              <div class="row px-1 justify-content-between">
                <b-button variant="primary" @click="unFilter()"
                  >إلغاء البحث</b-button
                >
                <b-button variant="info" @click="filtered()">بحث</b-button>
              </div>
            </div>
          </div>
        </collapse-header>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-3">
          <div class="sidebar">
            <!--Widget Start-->
            <basc-card class="filter_ngo_list">
              <div class="d-flex align-item-center">
                <feather-icon icon="FilterIcon" size="17" class="mx-25" />
                <h6>بحث بحسب</h6>
              </div>
              <div>
                <hr />
              </div>

              <b-form-group label="اسم المنظمة">
                <b-form-input
                  id="basicInput"
                  v-model="nameOrg"
                  placeholder=""
                />
              </b-form-group>

              <form-select
                label="الفئة المستهدفة"
                v-model="selectedCategories"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="governorate"
                ep="v2/guest/selects/age-categories"
                multiple
              />

              <form-select
                label="التصنيف"
                v-model="selectedClassi"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="selectedCategories"
                ep="v2/guest/selects/classifications"
              />
              <form-select
                label="المحافظة"
                v-model="selectedGovernorate"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="sgovernorate"
                ep="v2/guest/selects/governorates"
              />

              <form-select
                label="الشكل القانوني "
                v-model="selectedLegals"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="selectedLegals"
                ep="v2/guest/selects/legal-forms"
              />
              <div class="row px-1 d-flex justify-content-between">
                <b-button variant="primary" @click="unFilter()"
                  >إلغاء البحث</b-button
                >
                <b-button variant="info" @click="filtered()">بحث</b-button>
              </div>
            </basc-card>
          </div>
        </div>
        <div class="col-lg-9 col-md-12 col-12 mb-3">
          <basc-card>
            <div>
              <div
                v-if="loading"
                class="d-flex justify-content-center flex-wrap"
              >
                <b-skeleton v-for="n in 8" :key="n" class="skeleton_ngo_list">
                </b-skeleton>
              </div>
              <!-- <div v-if="loading" class="loading-overlay"></div> -->
              <div v-else>
                <div class="row">
                  <div
                    class="col-lg-3 col-md-4 col-sm-6 col-6"
                    v-for="org in ngo_list.data"
                    :key="org.id"
                  >
                    <ngo-card
                      :id="org.id"
                      :name_ngo="org.name_ar"
                      :logo="org.logo"
                    ></ngo-card>
                  </div>
                  <alert
                    v-if="ngo_list.data.length === 0"
                    class="w-100"
                    :massage="$t('alert')"
                  ></alert>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center">
              <pagination
                v-model="currentPage"
                :total-rows="ngo_list.pagination.total_row"
                :per-page="ngo_list.pagination.per_page"
                align="middle"
                class="mt-3 mb-2"
              >
              </pagination>
            </div>
          </basc-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Slider from "../../components/Slider";
import NgoCard from "../../components/NgoCard";
import CollapseHeader from "../../../../@core/components/app-collapse/CollapseHeader.vue";
import vSelect from "vue-select";
import { AlertCircleIcon } from "vue-feather-icons";
import FormSelect from "@/components/form-select";
import HeaderTitle from "../../components/HeaderTitle.vue";
import Pagination from "@/components/pagination";
import {
  BButton,
  BFormGroup,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BSpinner,
  BAlert,
  BSkeleton,
} from "bootstrap-vue";
import Alert from "@/components/Alert";
import BascCard from "../../components/BascCard.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Slider,
    BButton,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    CollapseHeader,
    vSelect,
    BascCard,
    FormSelect,
    BSpinner,
    BAlert,
    AlertCircleIcon,
    HeaderTitle,
    NgoCard,
    Alert,
    Pagination,
    BSkeleton,
  },

  data() {
    return {
      currentPage: 1,
      nameOrg: "",
      selectedGovernorate: "",
      selectedClassi: "",
      selectedCategories: [],
      selectedLegals: "",
    };
  },
  methods: {
    dispatchFilter() {
      this.$store.dispatch("NgoHome/ngoList/getNgoList", {
        name: this.nameOrg,
        governorate: this.selectedGovernorate,
        legal_form: this.selectedLegals,
        page: this.currentPage,
        classification: this.selectedClassi,
        age_categories: this.selectedCategories,
      });
    },
    unFilter() {
      this.currentPage = 1;
      this.nameOrg = "";
      this.selectedGovernorate = "";
      this.selectedClassi = "";
      this.selectedCategories = [];
      this.selectedLegals = "";
      this.dispatchFilter();
    },
    filtered() {
      this.currentPage = 1;
      this.dispatchFilter();
    },

    changePage() {
      this.dispatchFilter();
    },
  },
  watch: {
    currentPage(value) {
      this.nameOrg = "";
      this.selectedGovernorate = "";
      this.selectedLegals = "";
      this.changePage();
    },
  },

  computed: {
    ...mapGetters("NgoHome/ngoList", [
      "ngo_list",
      "governorate",
      "legals",
      "loading",
    ]),
  },

  created() {
    this.dispatchFilter();
  },
};
</script>

<style lang="scss">
.filter_small_screen {
  display: none;
}
.filter_ngo_list {
  max-width: 300px;
  min-height: 500px;
}
.skeleton_ngo_list {
  height: 225px;
  width: 225px;
  margin: 5px;
}

[dir] .b-skeleton {
  background-color: #eee;
}
.b-skeleton-animate-wave {
  &:after {
    background: linear-gradient(
      100deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent
    );
  }
}

@media (max-width: 1030px) {
  .sidebar {
    display: none;
  }
  .filter_small_screen {
    display: block;
  }
}
@media (max-width: 430px) {
  .skeleton_ngo_list {
    width: 100px;
    height: 150px;
  }
}
</style>
